import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge has to know our replaced type scale (`text-md`, `text-3xl`…), otherwise it reads
// `text-md` as a colour and lets a later `text-ink` silently drop the size.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['xs', 'sm', 'base', 'md', 'lg', 'xl', '2xl', '3xl', '4xl'] }],
    },
  },
});

/** Join class names; a later class wins over an earlier one for the same property. */
export const cn = (...inputs) => twMerge(clsx(inputs));
